import { useMemo } from "react";

type OptionsSource = Record<string, string>;

interface DropdownOption {
  label: string;
  value: string;
}

/**
 * A reusable hook to format key-value data (like bank or nationality lists)
 * into { label, value } pairs for Select dropdowns.
 *
 * Example:
 *   Input: { HBL: "Habib Bank Limited", MCB: "Muslim Commercial Bank" }
 *   Output: [
 *     { label: "Habib Bank Limited", value: "habib_bank_limited" },
 *     { label: "Muslim Commercial Bank", value: "muslim_commercial_bank" }
 *   ]
 */
export const useDropdownOptions = (source?: OptionsSource): DropdownOption[] => {
  return useMemo(() => {
    if (!source || typeof source !== "object") return [];

    return Object.entries(source).map(([_, label]) => ({
      label,
      value: label,
    }));
  }, [source]);
};
